// extracted by mini-css-extract-plugin
export default {"app-layout":"app_app-layout__gxNi6"};